import Component from '../abstracts/Component';
import '../../jwplayer.js';

/**
 Video component
 */
export default class VideoComponent extends Component {

  static get SELECTORS() {
    return {
      videoWrapper: '.video-wrapper',
      playSelector: '.js-video-play',
      mainModule: '.js-video-mainModule',
      players: {},
    };
  }

  static bindEvents() {

    if ($(VideoComponent.SELECTORS.playSelector).length) {
      $(VideoComponent.SELECTORS.playSelector).on('click', function () {

        let target = $(VideoComponent.SELECTORS.playSelector).data('videoTarget');
        let player = VideoComponent.SELECTORS.players[$(target)[0]];

        console.info('[VIDEO] player', player);

        if (player) {
          console.log("[Video] Start playing video...");
          player.play();
          $('body').addClass('video-in');
        }

      });
    }
    ;

    if ($(VideoComponent.SELECTORS.videoWrapper).length) {

      $(window).on('load resize scroll', function (e) {

        $(VideoComponent.SELECTORS.videoWrapper).each(function (i, videoWrapper) {


          if ($(this).data("startOnScroll")) {

            videoWrapper = $(videoWrapper);

            var runtime = VideoComponent.SELECTORS.players[videoWrapper.data('playerRuntime')];


            if (!videoWrapper.data('userPaused') && runtime) {

              if (VideoComponent.isElementInViewport(videoWrapper)) {

                if (runtime.getState() != 'playing') {

                  console.debug("[DataVideo] Player enters in viewport, start playing");

                  runtime.play();
                }

              } else {

                if (runtime.getState() == 'playing') {
                  console.debug("[DataVideo] Player exits from viewport, pausing playback");
                  runtime.pause();
                }
              }
            }
          }
        });
      });
    }
  }

  static getOpts(playerElement) {


    var data = $(playerElement).data();
    var opts = {
      file: data['videoUrl'],
      aspectratio: data['aspectratio'] || '16:9',
      autostart: data['autostart'],
      controls: data['controls'],
      image: data['videoPoster'],
      mute: data['mute'],
      primary: data['primary'] || 'html5',
      repeat: data['repeat'],
      displaytitle: data['displaytitle'],
      displaydescription: data['displaydescription'],
      captionsColor: data['captionsColor'],
      captionsFontSize: data['captionsFontSize'],
      captionsFontFamily: data['captionsFontFamily'],
      captionsFontOpacity: data['captionsFontOpacity'],
      captionsBackgroundColor: data['captionsBackgroundColor'],
      captionsBackgroundOpacity: data['captionsBackgroundOpacity'],
      captionsEdgeStyle: data['captionsEdgeStyle'],
      captionsWindowColor: data['captionsWindowColor'],
      captionsWindowOpacity: data['captionsWindowOpacity'],
      width: '100%',
      stretching: 'fill',
      skin: {name: "maxmara"}
    };

    if (typeof data['sharing'] !== 'undefined' && data['sharing'].length != 0) {
      var sharing = {};

      if (typeof data['sharingLink'] != 'undefined' && data['sharingLink'].length != 0) {
        sharing.link = data['sharingLink'];
      }

      if (typeof data['sharingHeading'] != 'undefined' && data['sharingHeading'].length != 0) {
        sharing.heading = data['sharingHeading'];
      }

      if (typeof data['sharingSites'] != 'undefined' && data['sharingSites'].length != 0) {
        sharing.sites = data['sharingSites'].split(',');
      }

      opts.sharing = sharing;
    }

    return opts;

  }

  isElementInViewport(el) {
    const $window = $(window);
    let $elem = $(el);
    let docViewTop = $window.scrollTop();
    let docViewBottom = docViewTop + $window.height();
    let elemTop = $elem.offset().top;
    let elemBottom = elemTop + $elem.height();

    return ((elemBottom > docViewTop && elemBottom < docViewBottom) || (elemTop > docViewTop && elemTop < docViewBottom));
  }


  setup() {
    $('*[data-video-url]').each(function (i, e) {


      let wrapperContainer = $(e).closest(VideoComponent.SELECTORS.videoWrapper);

      let wrapper;

      wrapper = $(parent).find(VideoComponent.SELECTORS.videoWrapper);

      if (!$(this).data('asyncSrc')) {
        VideoComponent.initPlayer(wrapper, e);
      } else {
        window.onload = VideoComponent.initPlayer(wrapper, e);
      }

    });
  }


  static initPlayer(wrapper, e) {

    var opts = VideoComponent.getOpts(e);

    if (!wrapper.data('playerRuntime')) {
      console.debug("[Video] Options", opts);

      var playerInstance = jwplayer(e);


      playerInstance.setup(opts).on('ready', function () {

        VideoComponent.SELECTORS.players[i] = playerInstance;

        wrapper.data('playerRuntime', i)

      }).on('setupError', function (error) {

        console.error("[DataVideo] Error ->", error.message);

      }).on('pause', function () {

        if (VideoComponent.isElementInViewport(wrapper)) {
          wrapper.data('userPaused', true);
        }

        let player = VideoComponent.SELECTORS.players[$([wrapper]).find(VideoComponent.SELECTORS.videoWrapper).data('playerRuntime')];

        if (player.getState() == 'playing') {
          player.pause();
        }

      }).on('start', function () {
        let player = VideoComponent.SELECTORS.players[$([wrapper]).find(VideoComponent.SELECTORS.videoWrapper).data('playerRuntime')];

        if (player.getState() != 'playing') {
          player.play();
        }
      });
    }
  }


  init() {
    console.info("[Video] init");
    jwplayer.key = "i/yVrpJoBLKdI0LD8HWuelhPhPNemCtKsh+25vgbLayOOQUw";
    this.setup();

    VideoComponent.bindEvents();
  }


  render() {
    super.render();
    this.init();
  }
}
